import { ContractType } from 'src/apis/contract-management/types';

export const contractTypeLabels: { [Key in ContractType]: string } = {
  FMCT: 'Frame Contract',
  DECT: 'Derived Contract',
  LECT: 'Legacy Contract',
};
